import { NextRequest, NextResponse } from 'next/server'
import Anthropic from '@anthropic-ai/sdk'
import { query, queryOne } from '@/lib/db'

const client = new Anthropic({ apiKey: process.env.ANTHROPIC_API_KEY })

export async function POST(req: NextRequest) {
  const { message, shop_id, user_role, history } = await req.json()

  const today = new Date().toISOString().split('T')[0]
  const monthStart = new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0]

  const [articles, caisse, charges, retraits, shop] = await Promise.all([
    query<any>('SELECT name, stock, ras_mel, prix_vente, prix_min, stock_alert FROM articles WHERE shop_id = ?', [shop_id]),
    queryOne<any>(`
      SELECT cs.*,
        COALESCE(SUM(v.total),0) as total_ventes,
        COALESCE((SELECT SUM(r.montant) FROM retraits r WHERE r.caisse_session_id = cs.id),0) as total_retraits,
        COALESCE((SELECT SUM(c.montant) FROM charges c WHERE c.caisse_session_id = cs.id),0) as total_charges
      FROM caisse_sessions cs LEFT JOIN ventes v ON v.caisse_session_id = cs.id
      WHERE cs.shop_id = ? AND cs.date = ? GROUP BY cs.id
    `, [shop_id, today]),
    query<any>('SELECT categorie, SUM(montant) as total FROM charges WHERE shop_id = ? AND date >= ? GROUP BY categorie', [shop_id, monthStart]),
    query<any>('SELECT montant, note FROM retraits WHERE shop_id = ? AND DATE(created_at) = ?', [shop_id, today]),
    queryOne<any>('SELECT name FROM shops WHERE id = ?', [shop_id]),
  ])

  const soldeTh = caisse
    ? parseFloat(caisse.solde_ouverture) + parseFloat(caisse.total_ventes) - parseFloat(caisse.total_retraits) - parseFloat(caisse.total_charges)
    : null

  const isPatron = user_role === 'patron'

  const systemPrompt = `Tu es l'assistant IA de la boutique "${shop?.name}".
Réponds en dialecte tunisien (darija) ou français selon la langue posée. Sois concis et utilise des emojis.
${isPatron ? '' : 'Note: cet utilisateur est vendeur/caissier - ne montre pas ras mel ni bénéfices.'}

=== DONNÉES (${today}) ===
CAISSE: ${caisse ? `Solde: ${soldeTh?.toFixed(3)} DT | Ventes: ${parseFloat(caisse.total_ventes).toFixed(3)} DT | Retraits: ${parseFloat(caisse.total_retraits).toFixed(3)} DT | Charges: ${parseFloat(caisse.total_charges).toFixed(3)} DT` : 'Pas encore ouverte'}
RETRAITS JOUR: ${retraits.map((r: any) => `${r.montant} DT (${r.note})`).join(', ') || 'Aucun'}
CHARGES MOIS: ${charges.map((c: any) => `${c.categorie}: ${parseFloat(c.total).toFixed(3)} DT`).join(', ') || 'Aucune'}
ARTICLES (${articles.length}): ${articles.slice(0, 40).map((a: any) => `${a.name}[stock:${a.stock}${a.stock < a.stock_alert ? '⚠️' : ''}${isPatron ? `,rm:${a.ras_mel},pv:${a.prix_vente}` : ''}]`).join(', ')}
${articles.length > 40 ? `...et ${articles.length - 40} autres` : ''}
=== FIN ===
Si ma3andekch el info: dis-le clairement.`

  const response = await client.messages.create({
    model: 'claude-haiku-4-5-20251001',
    max_tokens: 500,
    system: systemPrompt,
    messages: [
      ...(history || []).slice(-6).map((m: any) => ({ role: m.role, content: m.content })),
      { role: 'user', content: message },
    ],
  })

  return NextResponse.json({
    response: response.content[0].type === 'text' ? response.content[0].text : 'Erreur'
  })
}
